import { createContext } from 'react';

export type Variant = 'screen' | 'dialog';

export const DocumentContext = createContext<{
  variant: Variant;
}>({
  variant: 'screen',
});

export function generateVariantValues<
  T extends {
    [key in Variant]: any;
  },
>(values: T) {
  function getVariantValue<K extends Variant>(size: K): T[K] {
    return values[size];
  }
  return getVariantValue;
}
